<p>
  report-number-attendees-print-certificate works!
</p>
